import { userRoles } from '../constants/AppConstants';
import { ENVIRONMENT } from '../constants/AppConstants';
const bcrypt = require('bcryptjs');

class AuthenticationHelper {
  checkUserAuthorization = (user) => {
    //Dont allow internal and external reviewer
    return (
      user.user_role_key !== userRoles.INTERNAL_REVIEWER &&
      user.user_role_key !== userRoles.EXTERNAL_REVIEWER
    );
  };

  getVersionUpdate(currentVersion, newVersion) {
    let versionUpdate = false;
    if (typeof newVersion + typeof currentVersion == 'stringstring') {
      var newVersionArray = newVersion.split('.'),
        currentVersionArray = currentVersion.split('.'),
        len = Math.max(newVersionArray.length, currentVersionArray.length);

      for (var i = 0; i < len; i++) {
        if (
          (newVersionArray[i] &&
            !currentVersionArray[i] &&
            parseInt(newVersionArray[i]) > 0) ||
          parseInt(newVersionArray[i]) > parseInt(currentVersionArray[i])
        ) {
          versionUpdate = true;
          break;
        } else if (
          (currentVersionArray[i] &&
            !newVersionArray[i] &&
            parseInt(currentVersionArray[i]) > 0) ||
          parseInt(newVersionArray[i]) < parseInt(currentVersionArray[i])
        ) {
          break;
        }
      }
    }
    return versionUpdate;
  }

  // Web stub: not supported
  openDownloadLink = () => {
    throw new Error('openDownloadLink is not supported on web.');
  };

  comparePin = (currentUserpin, enteredPin) => {
    return new Promise((resolve, reject) => {
      try {
        bcrypt.compare(enteredPin, currentUserpin, (err, pinMatched) => {
          if (err) reject(err);
          else resolve(pinMatched);
        });
      } catch (err) {
        reject(err);
      }
    });
  };
}

export default new AuthenticationHelper();
